export const properties = (state) => state?.entities?.property;
export const propertiesList = (state) =>
  properties(state) ? Object.values(properties(state)) : [];
export const getPropertyById = (state, id) => properties(state)?.[id];
